import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة زوايا المثلث";
const DESCRIPTION =
  "استخدم حاسبة زوايا المثلث لحساب الزوايا المجهولة في المثلث باستخدام الزوايا المعروفة. تعلم كيفية تصنيف المثلثات وحساب زواياها باستخدام القوانين الهندسية والدوال المثلثية.";
const KEYWORDS =
  "حاسبة زوايا المثلث, قياس الزوايا, مثلث قائم الزاوية, مثلث حاد الزوايا, مثلث منفرج الزوايا, دوال مثلثية, الجيب والجتا, حساب الزوايا";
const OG_URL =
  "https://do-calculate.com/calculator/ar/triangle-angle-calculator/";
function TriangleAnglesCalculator() {
  const [firstAngle, setFirstAngle] = useState(0);
  const [secondAngle, setSecondAngle] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (firstAngle && secondAngle) {
        const sumOfKnownAngles = parseInt(firstAngle) + parseInt(secondAngle);
        setResult(180 - sumOfKnownAngles);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب الزاوية المجهولة في المثلث باستخدام
                  المعادلة التالية:
                </p>
                <p>
                  <strong>
                    الزاوية المجهولة = 180° - (مجموع الزاويتين المعروفتين)
                  </strong>
                </p>
                <ul>
                  <li>
                    ادخل قياس الزاويتين المعروفتين في المثلث لحساب الزاوية
                    المجهولة.
                  </li>
                  <li>
                    في حالة المثلث قائم الزاوية، يمكن حساب الزاوية المجهولة
                    باستخدام الدوال المثلثية (الجيب، الجتا، الظا، الظتا).
                  </li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب الزوايا في المثلث
                  بطريقة بسيطة وسهلة.
                </p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div
                      className="form-group d-flex align-items-center"
                      htmlFor="firstAngle"
                    >
                      <b>
                        <label className="form-label ms-2">
                          ادخل قياس الزاوية الأولى (بالدرجات)
                        </label>
                      </b>
                      <input
                        id="firstAngle"
                        type="number"
                        value={firstAngle}
                        onChange={(e) => setFirstAngle(e.target.value)}
                        placeholder="أدخل قياس الزاوية الأولى"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div
                      className="form-group d-flex align-items-center"
                      htmlFor="secondAngle"
                    >
                      <b>
                        <label className="form-label ms-2">
                          ادخل قياس الزاوية الثانية (بالدرجات)
                        </label>
                      </b>
                      <input
                        id="secondAngle"
                        type="number"
                        value={secondAngle}
                        onChange={(e) => setSecondAngle(e.target.value)}
                        placeholder="أدخل قياس الزاوية الثانية"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">النتيجة:</h4>
                      <p className="text-white">
                        زاوية المثلث الثالثة = {result}°
                      </p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>خطوات الحل:</h4>
                        <ol>
                          <li>
                            حساب مجموع الزاويتين: {firstAngle}° + {secondAngle}°
                            = {parseInt(firstAngle) + parseInt(secondAngle)}°
                          </li>
                          <li>
                            حساب الزاوية المجهولة: 180° -{" "}
                            {parseInt(firstAngle) + parseInt(secondAngle)}° ={" "}
                            {result}°
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">أنواع المثلثات</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      تصنيف المثلثات بناءً على الزوايا
                    </h2>
                  </u>
                  <p>
                    يمكن تصنيف المثلثات بناءً على قياسات زواياها إلى الأنواع
                    التالية:
                  </p>
                  <ul>
                    <li>
                      <strong>المثلث قائم الزاوية:</strong> مثلث يحتوي على زاوية
                      قائمة (90°).
                    </li>
                    <li>
                      <strong>المثلث الحاد الزوايا:</strong> مثلث جميع زواياه
                      حادة (أقل من 90°).
                    </li>
                    <li>
                      <strong>المثلث المنفرج الزاوية:</strong> مثلث يحتوي على
                      زاوية منفرجة (أكبر من 90°).
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: مثلث قائم الزاوية بزاويتين 30° و60°.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      طرق حساب الزوايا المجهولة
                    </h2>
                  </u>
                  <p>
                    يمكن حساب الزوايا المجهولة في المثلث بعدة طرق، بما في ذلك:
                  </p>
                  <ul>
                    <li>
                      استخدام المعادلة: الزاوية المجهولة = 180° - مجموع
                      الزاويتين المعروفتين.
                    </li>
                    <li>
                      في المثلث قائم الزاوية، يمكن استخدام الدوال المثلثية مثل
                      الجيب والجتا لحساب الزاوية المجهولة.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كانت زاويتان في مثلث قائمتين (45° و45°)، فإن
                    الزاوية الثالثة ستكون 90°.
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TriangleAnglesCalculator;
